<template>

  <div class="page_container">

    <div class="scrollable_content">

      <!-- <div class="text_intro">
        注意：需要升级最新版本（1.3.4及以上）可使用最新功能，部分应用商店新版审核中，请耐心等待。大会员功能将于2015.11.20日调整售价为5000硬币，已购买用户不受影响，感谢支持！
      </div> -->

    
      <div v-for="(item,index) in pdfItem" :key="index">


        <div class="item_row">

          <function-item-layout :item="item1" @send-message-to-android="sendMessageToAndroid" v-for="(item1,index) in item" :key="index" />
      
        </div>

      
        

        
      </div>
      
     



    


      <div class="rule">
        <div class="rule_title">
          注意事项
        </div>
        <div class="rule_text">
          1.所有功能付费后终身使用
        </div>
        <div class="rule_text">
          2.已解锁功能不可抵扣终身大会员
        </div>
        <div class="rule_text">
          3.虚拟产品一经出售不予退款
        </div>
        
        
      </div>


      

      <div>
        <PdfIntroduce v-show="uniqueName == 'pdf'"></PdfIntroduce>
      </div>

      <div>
        <YunCikuIntroduce v-show="uniqueName == 'yunciku'"></YunCikuIntroduce>
      </div>

      <div>
        <DahuiyuanIntroduce v-show="uniqueName == 'member'"></DahuiyuanIntroduce>
      </div>

      <div>
        <MiaojiIntroduce v-show="uniqueName == 'miaoji'"></MiaojiIntroduce>
      </div>


      <div>
        <BijiIntroduce v-show="uniqueName == 'biji'"></BijiIntroduce>
      </div>

      <div>
        <AudioExportIntroduce v-show="uniqueName == 'yinpin'"></AudioExportIntroduce>
      </div>

      







    </div>
    <div class="bottom_layout">

      <div class="bottom_layout_left">
        <!-- {{ currentEquipmentStatus === 0 ? `${currentCoinPrice}硬币` : '已解锁' }} -->
        <span class="bottom_left_down">

          硬币余额
          
          <span style="color:red"> {{totalCoinCount}}</span>

          
          
          
        
        </span>
      </div>
  
      <div class="bottom_layout_right">
        
        <van-button 
        :disabled="isButtonDisabled"
    class="buttom_top_up" 
    type="success"
    :style="{ backgroundColor: currentEquipmentStatus === 0  ? '' : '#9da3a3',

    // color: currentEquipmentStatus === 0  ? '' : '#000000'
  
  }"

  @click="androidShowTopUp"
    
  >
    {{ currentEquipmentStatus === 0 ? (currentCoinPrice > totalCoinCount ? '硬币不足请充值' : '解锁') : '已解锁' }}
  </van-button>
      </div>
  
    </div>
  </div>

  
 



  
  

  
    
  </template>
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import {getUserEquipmentItems,getUserCoinCount} from '@/api/apiService';
  import PdfIntroduce from '@/components/PdfIntroduce.vue';
  import FunctionItemLayout from '@/components/FunctionItemLayout.vue';
  import YunCikuIntroduce from '@/components/YunCikuIntroduce.vue';
  import DahuiyuanIntroduce from '@/components/DahuiyuanIntroduce.vue';

  import MiaojiIntroduce from '@/components/MiaojiIntroduce.vue';
  import BijiIntroduce from '@/components/BijiIntroduce.vue';
  import AudioExportIntroduce from '@/components/AudioExportIntroduce.vue';

  const pdfItem = ref([]);
  
  const selectedIndex = ref(-1)

  const uniqueName = ref('')
  const equipmentName = ref('')
  const equipmentNameParam = ref('')
  const isButtonDisabled = ref(true)

  import { useRouter } from 'vue-router';

  const router = useRouter();

  

  

  const currentCoinPrice = ref(0)

  const currentEquipmentStatus = ref(0) //0 未解锁 1  解锁

  const currentEquipmentId = ref(-1)
  //当前金币总数
  const totalCoinCount = ref(0)

  



 

  async function androidShowTopUp() {

  if (window.AndroidInterface && typeof window.AndroidInterface.showTopUp === 'function') {
    if (currentEquipmentStatus.value === 0) {
      if (currentCoinPrice.value > totalCoinCount.value) {
        try {
          const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };


          //设置充值列表
          const topUpCountList = [500, 1000, 1500, 2500, 3500, 5000];
          window.AndroidInterface.showTopUp(JSON.stringify(data),JSON.stringify(topUpCountList));
        } catch (error) {
          console.error('Error calling showTopUp:', error);
        }
      } else {
        try {
          const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
          window.AndroidInterface.showPay(JSON.stringify(data));
        } catch (error) {
          console.error('Error calling showUnlock:', error);
        }
      }
    }
  } else {
    console.warn('AndroidInterface or showTopUp method is not defined');
  }
}





  
  const sendMessageToAndroid = (id) => {
  const intId = parseInt(id, 10);

  selectedIndex.value = intId;

  

    // 遍历二维数组，找到并取消之前选中的项
    pdfItem.value.forEach(row => {
      row.forEach(item => {
        if (item.isChoosen) {
          item.isChoosen = false;
        }
      });
    });

    // 遍历二维数组，找到并选中新项
    pdfItem.value.forEach(row => {
      row.forEach(item => {
        if (item.index === intId) {
          item.isChoosen = true;
          uniqueName.value = item.uniqueName;
          currentCoinPrice.value = item.price
          currentEquipmentStatus.value = item.status
          currentEquipmentId.value = item.index
          equipmentName.value = item.name
        }
      });
    });
};

// function delay(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }
// async function refreshData() {
//   try {
    
    
    
//     return "1";
//   } catch (error) {
    
//     return "0"; // or any other error code/value you prefer
//   }
// }

// 定义一个全局函数来调用 refreshData 并传递结果给 Android
window.callTopUpRefreshData = function() {

  
    
    getUserTotalCoinCount().then(result => {

      totalCoinCount.value = result;

      

    if (window.AndroidInterface && window.AndroidInterface.onTopupRefreshDataResult) {

      const data = {
        status: 1,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };

      

      


      window.AndroidInterface.onTopupRefreshDataResult(JSON.stringify(data));
    }else{
      const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
      window.AndroidInterface.onTopupRefreshDataResult(JSON.stringify(data));
    }
  }).catch(error => {
    console.error('Error calling refreshData:', error);
    if (window.AndroidInterface && window.AndroidInterface.onTopupRefreshDataResult) {
      const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
      window.AndroidInterface.onTopupRefreshDataResult(JSON.stringify(data));
    }
  });
}


async function payRefresh(){

  try {
    const [coinCount, equipments] = await Promise.all([
      getUserTotalCoinCount(),
      getEquipments()
    ]);
   

    totalCoinCount.value = coinCount;
    pdfItem.value = equipments

    


    return "1";

   

    
  } catch (error) {
    console.error('Error refreshing data:', error);
    return "0";
   
    


}

}




window.callPayRefreshData =  function() {

  payRefresh().then(result => {
    if(result == "1"){
      if (window.AndroidInterface && window.AndroidInterface.onPayRefreshDataResult) {
        const data = {
        status: 1,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
      window.AndroidInterface.onPayRefreshDataResult(JSON.stringify(data));
    }else{
      const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
      window.AndroidInterface.onPayRefreshDataResult(JSON.stringify(data));
    }
    }
    
    
  }).catch(error => {
    console.error('Error calling refreshData:', error);
    if (window.AndroidInterface && window.AndroidInterface.onPayRefreshDataResult) {
      const data = {
        status: 0,
        equipmentId: currentEquipmentId.value,
        totalCoinCount: totalCoinCount.value,
        coinPrice: currentCoinPrice.value,
        equipmentName: equipmentName.value,
        
      };
      window.AndroidInterface.onPayRefreshDataResult(JSON.stringify(data));
    }
  });


  // if (window.AndroidInterface && window.AndroidInterface.onRefreshDataResult) {
  //     window.AndroidInterface.onRefreshDataResult("1");
  // }

  

  
}

   






  onMounted(() => {

    //获取.href + '?id=' + id;传递的参数
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const equipmentName = params.get('equipmentName');
    
    
    if(id){
      selectedIndex.value = parseInt(id, 10);
      
    }

    if(equipmentName){
      equipmentNameParam.value = equipmentName
    }
    

    

    getUserTotalCoinCount().then(result => {
      totalCoinCount.value = result;
    }).catch(() => {
      router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    });

   
    getEquipments().then(result => {
      pdfItem.value = result;
      isButtonDisabled.value = false
    }).catch(() => {

      router.replace({ name: 'Wrong' }); // 跳转到错误页面并删除栈内所有页面
    });



})


// Clean up when the component is unmounted
onBeforeUnmount(() => {
  delete window.refreshData;
});



async function getEquipments(){

  const response = await getUserEquipmentItems();
if (response.code === 0 && response.msg === 'success') {


  if(equipmentNameParam.value!=""){
    response.equipments.forEach((item) => {
      if(item.uniqueName == equipmentNameParam.value){
        selectedIndex.value = item.id       
      }
    });
  }



  
  const list = response.equipments.map((item, index) => {

    if(selectedIndex.value == -1){
      if(index == 0 ){
        selectedIndex.value = item.id;
        equipmentName.value = item.name
      }
        
    }

    if(selectedIndex.value == item.id){
      uniqueName.value = item.uniqueName;
      currentCoinPrice.value = item.price
      currentEquipmentStatus.value = item.status
      currentEquipmentId.value = item.id
      equipmentName.value = item.name
    }

    item.isChoosen = item.id === selectedIndex.value;


    return {
      index: item.id,
      src: require('@/assets/' + item.imgUrl),
      name: item.name,
      price: item.price,
      status: item.status,
      expend: item.status === 1 ? '已解锁' : `${item.price}硬币`,
      isChoosen: item.isChoosen,
      uniqueName:item.uniqueName
    };
  });

  // 将 list 分割成包含两个元素的二维数组
  const chunkedArray = [];
    for (let i = 0; i < list.length; i += 2) {
      chunkedArray.push(list.slice(i, i + 2));
    }

    return chunkedArray
    
  
 
}



}


async function getUserTotalCoinCount(){


  const response = await getUserCoinCount();
    if (response.code === 0 && response.msg === 'success') {

      console.log(response.totalCoin);
      
      return response.totalCoin
      
    }
    return 0
}


  
  
  
  </script>
  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    
    overflow-y: auto;
    align-items: center
  }
  
  .scrollable_content {
    flex: 1;
    width: 90%;
    padding-bottom: 3rem; /* 确保内容不会被底部布局遮挡，调整高度以适应底部布局的高度 */
    
  }
  
  .item_row {
    display: flex;
    justify-content: space-between;
    
    flex-direction: row;
    margin-bottom: 0.5rem;
    align-items: center;
    justify-content: center;
    
    

  }
  





 
  








  .bottom_layout{
    position: fixed;
    width: 95%;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #ccc; /* 设置上边框为灰色 */
    padding-top: 0.2rem;

    padding-bottom: 0.5rem;

    
    

    background-color: white; /* 可选：设置背景颜色 */
    text-align: center; /* 可选：设置文本居中 */
    
    box-shadow: 0  rgba(0, 0, 0, 0.1); /* 可选：设置阴影效果 */
    
    

  }

  .bottom_layout_left{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 90%;
    font-size: 0.4rem;
    
    
  }

  .bottom_left_up{
    font-size: 0.5rem;
    color: red;
    margin-bottom: 0.1rem;
  }
  .bottom_left_down{
    font-size: 0.5rem;
    
  }
  .bottom_layout_right{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .buttom_top_up{
    width: 90%;

    
    height: 1.1rem;
    font-size: 0.45rem;
    background: #1296db;
    border: #1296db;
    
    
  }

  .rule {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: left;
    margin-top: 0.5rem;
  }

  .rule_title{
    font-size: 0.5rem;
    color: red;
    margin-top: 0.2rem;
    text-align: left;
    margin-left: 0.5rem;
  }
  .rule_text {
    font-size: 0.4rem;
    color: #000000;
    margin-top: 0.2rem;
    text-align: left;
    margin-left: 0.5rem;
  }


  .text_intro {
    
    color: #e72222;
    margin-top: 0.1rem;
    margin-left: 0.1rem;

    font-size: 0.4rem;
    text-align: left;
    
    
    
  }

  </style>